import React, {useContext, useEffect} from 'react';
import {withRouter} from 'react-router-dom';
import {Grid, Container} from '@material-ui/core';
import {makeStyles} from '@material-ui/core/styles';
import {Typography} from '@material-ui/core';
import {useFormPersistence} from 'components/forms/hooks';
import {useClearForm} from 'components/forms/hooks';
import {FormState} from 'components/forms/context';
import FormNavigation, {
    defaultBack,
    defaultNext,
} from 'components/forms/context/FormNavigation';
import {Alert} from '@material-ui/lab';
import {SiteUrls} from '../../../constants';
import ModalImage from 'components/ModalImage';

const useStyles = makeStyles(theme => ({
    root: {
        flexGrow: 1,
        '& > *': {
            marginBottom: '1em',
        },
    },
    control: {
        padding: theme.spacing(2),
    },
    text: {
        color: theme.palette.primary.main,
        fontWeight: 'bold',
        maxWidth: '400px',
    },
    submit: {
        color: 'white',
        backgroundColor: theme.palette.secondary.main,
    },
}));

const Success = ({
    history,
    reload = false,
    redirect = SiteUrls.SEA_SERVICE_DOCS,
}) => {
    const classes = useStyles();
    const {state} = useFormPersistence();
    const {setBackButton, setNextButton} = useContext(FormNavigation);
    const clearFormState = useClearForm(useContext(FormState).node);

    useEffect(() => {
        setBackButton({
            ...defaultBack,
            disabled: true,
        });
        setNextButton({
            ...defaultNext,
            label: 'Done',
            testHook: 'form-nav-done',
            onClick: () => {
                // Clear form state
                clearFormState();
                // Go home
                if (reload) {
                    window.location.reload();
                } else {
                    history.push(redirect);
                }
            },
        });

        const clearUnload = () => {
            clearFormState();
        }
        // Clear state if the user closes the window instead of clicking the button
        window.addEventListener('beforeunload', clearUnload);
        return () => {
            window.removeEventListener('beforeunload', clearUnload);
            
            setBackButton(defaultBack);
            setNextButton(defaultNext);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <Container>
            <Typography variant='h6' align='left'>
                Review
            </Typography>
            <Grid
                container
                direction='row'
                className={classes.root}
                justifyContent='space-evenly'
                alignItems='center'
            >
                {state.user_document_post_response?.user_images?.map(
                    (image, index) => (
                        <Grid item key={`review-document-${index}`}>
                            <ModalImage
                                src={image.thumb_signed_url}
                                fullSrc={image.signed_url}
                                alt={`uploaded document page ${index + 1}`}
                            />
                        </Grid>
                    )
                )}
            </Grid>
            <Alert severity='success'>
                Congratulations! Our system has found no errors in your
                paperwork. Your form has been saved. Click Done to return to
                your profile!
            </Alert>
        </Container>
    );
};

export default withRouter(Success);
